// extracted by mini-css-extract-plugin
module.exports = {"grossSalaryContainer":"Input_grossSalaryContainer__2BSdV","continue":"Input_continue__3gX24"};